module.exports = __webpack_public_path__ + "img/image.901660e.png";